module.exports = __webpack_public_path__ + "media/img/Scholarships2u-Logo-Light-6209a993de874b0603eb24a5ce91c3c3.svg";